import Vue from 'vue';
import currency from 'currency.js'

Vue.filter('currency', function (value, currencyCode = null, precision = 2) {
    if (typeof value === 'undefined') {
        return '';
    }

    let p = 0;
    let money = value.toString().split(".");
    if (money.length > 1) {
        p = money[1].length;
    }

    if (currencyCode === 840) {
        const USD = value => currency(value, { precision: p, symbol: '$' });
        return USD(value).format();
    } else if (currencyCode === 116) {
        const RIEL = value => currency(value, { precision: p, symbol: '៛' });
        return RIEL(value).format()
    } else if (currencyCode === 764) {
        const C = value => currency(value, { precision: p, symbol: '฿' });
        return C(value).format()
    } else if (currencyCode === 418) {
        const C = value => currency(value, { precision: p, symbol: '₭' });
        return C(value).format()
    } else {
        const C = value => currency(value, { precision: p, symbol: '' });
        return C(value).format()
    }
});
